















import BaseComponent from "@/components/base/BaseComponent";
import IllegallyWithdrawingFunds
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/withdrawal-kit/IllegallyWithdrawingFunds.vue";
import LegallyWithdrawingFunds
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/withdrawal-kit/LegallyWithdrawingFunds.vue";
import LoansDetails
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/withdrawal-kit/LoansDetails.vue";
import MoneyWithdrawalDetails
  from "@/components/dashboard/process-management/addingProcess/ProcessesForms/withdrawal-kit/MoneyWithdrawalDetails.vue";
import {MemberType} from "@/components/dashboard/process-management/model/ProcessManagmentTypes";
import {Component} from 'vue-property-decorator';

@Component({
  components: {LoansDetails, MoneyWithdrawalDetails, LegallyWithdrawingFunds, IllegallyWithdrawingFunds}
})
export default class MoneyWithdrawalProvidentFund extends BaseComponent {

  private memberType: MemberType = MemberType.EMPLOYEE
  private moneyWithdrawalProvidentFundRequest: any = {
    memberStatusType: MemberType.EMPLOYEE
  };
  private illegalWithdrawalDetails: any = null
  private legalWithdrawalDetails: any = null
  private legalWithdrawalDetailsDate: any = null


  handleRecognizedAnnuityFundsWithdrawalChange(withdrawalType: number, moneyAmount: number) {
    this.moneyWithdrawalProvidentFundRequest = {
      ...this.moneyWithdrawalProvidentFundRequest,
      rewardMoneySecondPart: withdrawalType,
      rewardMoneyAmountSecondPart: moneyAmount
    }

    this.$emit('updateChanges', this.moneyWithdrawalProvidentFundRequest)
  }

  handleBenefitWithdrawalChange(withdrawalType: number, moneyAmount: number) {
    this.moneyWithdrawalProvidentFundRequest = {
      ...this.moneyWithdrawalProvidentFundRequest,
      rewardMoney: withdrawalType,
      rewardMoneyAmount: moneyAmount
    }

    this.$emit('updateChanges', this.moneyWithdrawalProvidentFundRequest)
  }

  handleLoanSelectionChanged(loanSelection: number) {
    this.moneyWithdrawalProvidentFundRequest = {
      ...this.moneyWithdrawalProvidentFundRequest,
      loanDetailsCode: loanSelection
    }

    this.$emit('updateChanges', this.moneyWithdrawalProvidentFundRequest)
  }

  handleLegallyRadioSelection(value: any) {
    this.legalWithdrawalDetails = value

    if (this.legalWithdrawalDetails !== 1) {
      this.legalWithdrawalDetailsDate = null
    }

    this.moneyWithdrawalProvidentFundRequest = {
      ...this.moneyWithdrawalProvidentFundRequest,
      legalWithdrawalDetails: this.legalWithdrawalDetails,
      legalWithdrawalDetailsDate: this.legalWithdrawalDetailsDate
    };

    this.$emit('updateChanges', this.moneyWithdrawalProvidentFundRequest)
  }

  handleIllegallyRadioSelection(value: any) {
    this.illegalWithdrawalDetails = value

    this.moneyWithdrawalProvidentFundRequest = {
      ...this.moneyWithdrawalProvidentFundRequest,
      illegalWithdrawalDetails: this.illegalWithdrawalDetails
    }

    this.$emit('updateChanges', this.moneyWithdrawalProvidentFundRequest)
  }

  handleEndEmploymentDateChange(value: any) {
    this.legalWithdrawalDetailsDate = value

    if (this.legalWithdrawalDetails === 1) {
      this.moneyWithdrawalProvidentFundRequest = {
        ...this.moneyWithdrawalProvidentFundRequest,
        legalWithdrawalDetails: this.legalWithdrawalDetails,
        legalWithdrawalDetailsDate: this.legalWithdrawalDetailsDate
      };

      this.$emit('updateChanges', this.moneyWithdrawalProvidentFundRequest)
    }
  }
}
